import {useLanguageService} from "../../../../services/Language/languageService";
import {getLangDisplayName, getPossibleLanguages} from "../../../../services/languageUtils";
import {withTranslation} from "react-i18next";
import React, {useState} from "react";
import {ReactComponent as GlobeIco} from "../../../../../images/icons/globe.svg";
import {ReactComponent as ArrowBottomIco} from "../../../../../images/icons/arrow-bottom.svg";
import {ReactComponent as ArrowTopIco} from "../../../../../images/icons/arrow-top.svg";
import {Collapse} from "react-bootstrap";

interface Props {
    locale: string;
    languages: string[];
    renderListItem: (icon: JSX.Element, title: string, value: string, shareIcon: JSX.Element, link?: string, action?: any) => JSX.Element;
}

const FooterLanguages = ({languages, locale}: Props) => {
    const languageService = useLanguageService();
    const [expandLanguages, setExpandLanguages] = useState<boolean>(false);
    const possibleLanguages = getPossibleLanguages(languages);
    const [loadingIndex, setLoadingIndex] = useState(-1);

    if (possibleLanguages.length < 2) return null;

    const changeLocaleInternal = async (newLocale: string, index: number) => {
        if (newLocale !== locale) {
            setLoadingIndex(index);
            await languageService.change(newLocale);
            setExpandLanguages(false);
            setLoadingIndex(-1);
        }
    }

    return (
        <li className="footer-languages">
            <div className="footer-list-item-wrapper">
                <button className={"footer-list-item"}
                        aria-expanded={expandLanguages}
                        aria-controls="collapse_footer_languages"
                        onClick={() => setExpandLanguages(!expandLanguages)}
                        id="btn_footer_languages"
                >
                    <div className={"footer-list-icon"}>
                        <GlobeIco/>
                    </div>
                    <div className={"footer-list-content"}>
                        {getLangDisplayName(locale)}
                    </div>
                    <div className={"footer-list-action"}>
                        <div className="btn btn-sm btn-transparent btn-icon"
                        >
                            {expandLanguages ? <ArrowTopIco/> : <ArrowBottomIco/>}
                        </div>
                    </div>
                </button>
                <Collapse in={expandLanguages}>
                    <div id="collapse_footer_languages"
                         role="region"
                         aria-labelledby="btn_footer_languages"
                    >
                        {possibleLanguages.map((language, index) => (
                            <button key={language}
                                    className={`cursor-pointer footer-language-option ${language === locale ? 'active' : ''}`}
                                    onClick={() => changeLocaleInternal(language, index)}
                                    aria-current={language === locale ? 'true' : undefined}>
                                {getLangDisplayName(language)}
                                {loadingIndex === index &&
                                    <span className="left spinner-border spinner-border-sm ms-2"/>}
                            </button>
                        ))}
                    </div>
                </Collapse>
            </div>
        </li>
    )
}

export default withTranslation()(FooterLanguages)